import { render, staticRenderFns } from "./AccountText.vue?vue&type=template&id=08c30d2a"
import script from "./AccountText.vue?vue&type=script&lang=js"
export * from "./AccountText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports